import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext"
import useMediaUpload from "hooks/useMediaUpload"
import { useTranslation } from "react-i18next"
import { useLibraryTemplateSelector } from "store/hooks"
import { MediaType } from "@prisma/client"
import { ButtonV2 } from "components/v2/components/common/buttons"
import { educationalContentMediaUploadService } from "utils/library-template/educationalContentMediaUploadService"

const UploadEducationalContentMedia = () => {
    const { t } = useTranslation("common")
    const { libraryTemplate, educationalContent } = useLibraryTemplateSelector()
    const [editor] = useLexicalComposerContext()
    const { uploadImage, uploadVideo, isLoading } = useMediaUpload()

    const handleUpload = async (mediaType: MediaType) => {
        try {
            await educationalContentMediaUploadService({
                file: undefined,
                mediaType,
                libraryTemplate,
                educationalContent,
                uploadImage,
                uploadVideo,
                t,
                editor
            })
        } catch (error) {
            console.error("Error processing upload:", error)
        }
    }

    return (
        <>
            <div className="flex justify-between py-2">
                <ButtonV2
                    onClick={() => handleUpload(MediaType.IMAGE)}
                    text={t("upload_image", { ns: "educationalContent" })}
                    className="mb-3"
                    isDisabled={isLoading}
                />
                <ButtonV2
                    onClick={() => handleUpload(MediaType.VIDEO)}
                    text={t("upload_video", { ns: "educationalContent" })}
                    className="mb-3"
                    isDisabled={isLoading}
                />
            </div>
        </>
    )
}

export default UploadEducationalContentMedia
